import { useCallback, useEffect, useState } from 'react'
import { GetPlayerCoinHistoryGanamosResponse } from '../../Api/UserPanel/models'
import { getPlayerCoinHistoryGanamos } from '../../Api/UserPanel/UserPanel'


export const useGetPlayerCoinHistoryGanamos = ({ form, otherHierarchies = false, date }: { form: { name: string }, otherHierarchies?: boolean, date?: string }) => {
    const [playerCoinHistory, setPlayerCoinHistory] = useState<GetPlayerCoinHistoryGanamosResponse | null>(null)
    const [loading, setLoading] = useState(false)

    const getCoinHistory = useCallback(async () => {
        setLoading(true)
        const response = await getPlayerCoinHistoryGanamos({ name: form?.name?.trim(), otherHierarchies: otherHierarchies ?? false, date })
        setPlayerCoinHistory(response)
        setLoading(false)
    }, [form?.name, otherHierarchies, date])

    useEffect(() => {
        if (!form?.name) return;
        getCoinHistory();
    }, [getCoinHistory, form?.name]);

    return {
        playerCoinHistory,
        loading,
        getCoinHistory,
    }

}
